import Vue from 'vue';
export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/event-bus/index.js